class PdpRadios extends VariantSelects {
  constructor() {
    super();
    const shippingContainer = document.getElementById(
      `product-free-shipping-${this.dataset.section}`
    );
    if (shippingContainer) {
      this.shippingLabel = shippingContainer.querySelector(
        ".product-free-shipping__global"
      );
      this.shippingExtendedLabel = shippingContainer.querySelector(
        ".product-free-shipping__extended"
      );

      this.shippingTooltip = shippingContainer.querySelector(
        ".product-free-shipping__tooltip"
      );
    }
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.classList.remove("disabled");
      } else {
        input.classList.add("disabled");
      }
    });
  }

  updateOptions() {
    const fieldsets = Array.from(this.querySelectorAll("fieldset"));
    this.options = fieldsets.map((fieldset) => {
      return Array.from(fieldset.querySelectorAll("input")).find(
        (radio) => radio.checked
      ).value;
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const originalImage = $("img[id|='product-featured-image']");
    const newImage = this.currentVariant.featured_image;
    const element = originalImage[0];
    const variantId = this.currentVariant.id;

    Shopify.Image.switchImage(
      newImage,
      element,
      function (newImageSizedSrc, newImage, element) {
        jQuery(".slider-nav img").each(function () {
          var grandSize = $(this)
            .attr("src")
            .split("?")[0]
            .replace("_compact", "");

          newImageSizedSrc = newImageSizedSrc
            .split("?")[0]
            .replace("https:", "")
            .replace("http:", "");
          if (grandSize === newImageSizedSrc) {
            var item = $(this).closest(".item");
            item.trigger("click");
            jQuery(".item--variant-extra").hide();
            jQuery(
              '.item--variant-extra[data-variant-id="' + variantId + '"]'
            ).show();
            return false;
          }
        });
      }
    );
  }

  renderProductInfo(currentInput) {
    super.renderProductInfo(currentInput);

    if (this.currentVariant.metafields) {
      if (typeof this.shippingLabel != "undefined") {
        if (this.currentVariant.metafields.v2_free_shipping !== "") {
          this.shippingLabel.textContent =
            this.currentVariant.metafields.v2_free_shipping;
        } else {
          this.shippingLabel.textContent = this.shippingLabel.dataset.default;
        }
      }

      if (typeof shippingTooltip != "undefined") {
        if (this.currentVariant.metafields.v2_free_shipping_popover) {
          this.shippingTooltip.style.display = "inline-block";
          this.shippingTooltip.setAttribute(
            "title",
            this.currentVariant.metafields.v2_free_shipping_popover
          );
          this.shippingTooltip.dataset.originalTitle =
            this.currentVariant.metafields.v2_free_shipping_popover;
        } else if (this.shippingTooltip.dataset.default != "") {
          this.shippingTooltip.style.display = "inline-block";
          this.shippingTooltip.setAttribute(
            "title",
            this.shippingTooltip.dataset.default
          );
          this.shippingTooltip.dataset.originalTitle =
            this.shippingTooltip.title;
        } else {
          this.shippingTooltip.style.display = "none";
        }
      }

      if (typeof this.shippingExtendedLabel != "undefined")
        this.shippingExtendedLabel.textContent =
          this.currentVariant.metafields.v2_free_shipping_extended;
    }
  }
}

customElements.define("pdp-radios", PdpRadios);
